<template>
  <div class="flex flex-col bg-surface-100 dark:bg-surface-800" style="height: 100dvh; padding-left: var(--safe-l); padding-right: var(--safe-r)">
    <LayoutBarraGlobale />
    <!-- Scorre solo questo contenitore (la barra resta ferma in cima): le intestazioni `sticky` delle pagine si fermano sotto la barra -->
    <div class="min-h-0 flex-1 overflow-x-hidden overflow-y-auto" data-test="layout-scorrimento">
      <slot />
    </div>

    <LayoutAppSidebar />
    <LayoutComandiAttiviPannello />

    <LayoutAggiornamentoVersione :aperto="versioneNuova" :in-corso="aggiornamentoInCorso" @aggiorna="aggiorna" />

    <LayoutToastTopLayer />
    <LayoutToastDispositivo />
    <InstallPwaDialog :show-button="false" />
    <ConfirmDialog />
  </div>
</template>

<script setup lang="ts">
import { rimuoviServiceWorkerObsoleti } from "~/utils/serviceWorkerObsoleti";
// Layout dell'app dopo il login: barra globale in cima (notifiche, lingua, tema), menu laterale, finestre globali (operazioni asincrone, aggiornamento versione, installazione PWA),
// toast e controlli di sessione. Scorre un solo contenitore (il wrapper): la finestra no (base.css, html.layout-app).
const { isNew, setNew } = await useBuildVersion();

const versioneNuova = ref(isNew);
const aggiornamentoInCorso = ref(false);

useIdleLogout(20); // 20 minuti di inattività
useAltezzaApp();
useAvvisoDispositivo();

onMounted(() => document.documentElement.classList.add("layout-app"));
onBeforeUnmount(() => document.documentElement.classList.remove("layout-app"));

// Registra la versione attuale, svuota le cache e ricarica
async function aggiorna(): Promise<void> {
  aggiornamentoInCorso.value = true;
  await setNew();
  try {
    // tutte le cache del service worker (documents, suncore-*, workbox-*), non solo alcune: una pagina vecchia rimasta in cache
    // riporterebbe lo stesso buildId e la finestra tornerebbe
    const chiavi = await caches.keys();
    await Promise.all(chiavi.map((chiave) => caches.delete(chiave)));
    // le registrazioni del vecchio `/sw.js` (eliminato) si tolgono; un aggiornamento che fallisce non ferma le altre
    const registrazioni = await rimuoviServiceWorkerObsoleti();
    await Promise.allSettled(registrazioni.map((r) => r.update()));
    // rinfresca anche la cache HTTP del browser, altrimenti il reload può riservire l'HTML vecchio
    await fetch(window.location.href, { cache: "reload" });
  } catch (errore) {
    console.warn("[aggiornamento] pulizia cache incompleta:", errore);
  }
  window.location.reload();
}
</script>
